export default __webpack_public_path__ + "static/media/plesk.1c8c2398.png";